const SET_SELECT_CHILD = 'SET_SELECT_CHILD';

const initialState = {
    selectChild: null
}

const journalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECT_CHILD:
            return {
                ...state,
                selectChild: action.payload
            };
        default:
            return state;
    }
};

export default journalReducer;

export const actionSetSelectChild = (data) => {
    return {
        type: SET_SELECT_CHILD,
        payload: data
    }
};